export default {
  FULLWIDTH: 'fullwidth',
  BOXED: 'boxed',
};
